import { Injectable } from '@angular/core';
import _ from 'lodash';
import { ApiService } from 'src/app/services/api.service';
import { Observable, Subject } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookmarkService {

  hashTagQuery = new Subject<any>();
  refreshHashtags = new Subject<any>();
  removeHashtagsGlobal = new Subject<any>();
  
  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient
  ) {}

  // Aggerigate the bookmark function based on the module key
  aggBookmarkByDashboard(data: any[], dashboardKey:any) {
    const grouped = _.groupBy(data, 'dashboard_key');

    const result = Object.entries(grouped).map(([dashboard_key, items]: [string, any[]]) => {
      const { dashboard_nm, module_key, module_nm, module_icon } = items[0]; // Assume same for all items in the group
      const unread_bookmark = items.filter(item => !!item.shared_by_employee_name && item?.is_new=='Y').length;
      return {
        dashboard_key,
        dashboard_nm,
        module_key,
        module_nm,
        module_icon,
        unread_bookmark,
        bookmarks: items
      };
    });

    // Sort so the matching dashboardKey comes first
    const sortedResult = _.orderBy(result, [
      (item) => item.dashboard_key === dashboardKey ? 0 : 1
    ]);

    return sortedResult;
  }

  /**
   * Filters messages based on specified keys and search text.
   * @param messages - The array of messages to filter.
   * @param filterKeys - The keys to check for the search text.
   * @param searchText - The text to search for.
   * @returns Filtered array of messages.
   */
  filterBookmarkByKeys(messages: any[], filterKeys: string[], searchText: string): any[] {
    return messages.filter((obj) => {
      return filterKeys.some((key) => {
        return obj[key] && obj[key].toString().toLowerCase().includes(searchText.toLowerCase());
      });
    });
  }

  bookMarkQuery(data: any, widgetEndpoint:any) {
    if(!data['brand_key']) return new Observable((ob) => ob.next(undefined));
    return this.apiService.post(widgetEndpoint, data);
  }
  
  bookMarkUpdateQuery(data: any, widgetEndpoint:any) {
    return this.apiService.post(widgetEndpoint, data);
  }
  
  bookMarkShareQuery(data: any, widgetEndpoint:any): Observable<any> {
    if(this.apiService.getClientKey() && this.apiService.getEmpKey()) {
      let query: any = {
        "client_key": this.apiService.getClientKey(),
        "module_key": this.apiService.getModuleKey()
      }
      Object.assign(data, query)
    }
    return this.httpClient.post(`${environment.apiBaseUrl}/${widgetEndpoint}`, data) 
  }
  
  bookMarkGetBaseQuery(id: any) {
    let obj = { bookmark_key : id}
    return this.apiService.post("api/bookmarks/get-bookmark-by-id", obj);
  }
  
  unreadTotalBookmarkApi(obj: any) {
    return this.apiService.post("api/bookmarks/get-bookmark-unread-count", obj);
  }
  
  unreadMergeApi(obj: any) {
    return this.apiService.post("api/bookmarks/bookmark-readstatus-update", obj);
  }
}
